import api from './api';

export interface Contact {
  id: number;
  name: string;
  type: 'customer' | 'supplier';
  contact_person?: string;
  email?: string;
  phone?: string;
  address?: string;
  company_name?: string;
  tax_id?: string;
  credit_limit: number;
  payment_terms?: string;
  status: 'active' | 'inactive';
  notes?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateContactData {
  name: string;
  type: 'customer' | 'supplier';
  contact_person?: string;
  email?: string;
  phone?: string;
  address?: string;
  company_name?: string;
  tax_id?: string;
  credit_limit?: number;
  payment_terms?: string;
  status?: 'active' | 'inactive';
  notes?: string;
}

export const contactService = {
  async getAll(params?: { type?: string; status?: string; search?: string }) {
    const response = await api.get('/contacts', { params });
    return response.data;
  },

  async getById(id: number): Promise<Contact> {
    const response = await api.get(`/contacts/${id}`);
    return response.data;
  },

  async create(data: CreateContactData): Promise<Contact> {
    const response = await api.post('/contacts', data);
    return response.data;
  },

  async update(id: number, data: Partial<CreateContactData>): Promise<Contact> {
    const response = await api.put(`/contacts/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/contacts/${id}`);
  },

  async getByType(type: 'customer' | 'supplier') {
    const response = await api.get(`/contacts/type/${type}`);
    return response.data;
  },

  async search(query: string) {
    const response = await api.get(`/contacts/search/${query}`);
    return response.data;
  },
};

